'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _next = require('@alifd/next');

var _lodash = require('lodash');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _formatter = require('../formatter');

var _treeOperation = require('../treeOperation');

var _formFieldUtils = require('../formFieldUtils');

var _constant = require('../../vc-face-recognition/constant');

var _card = require('../card');

var _recommend = require('../recommend');

var _recommend2 = _interopRequireDefault(_recommend);

require('./style.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var SIZE = {
  large: 'medium',
  // large: 'large',
  medium: 'medium',
  middle: 'medium',
  small: 'small'
};

var SIZE_CLASS = {
  large: 'next-medium',
  // large: 'next-large',
  medium: 'next-medium',
  middle: 'next-medium',
  small: 'next-small'
};

var Base = (_temp = _class = function (_React$Component) {
  _inherits(Base, _React$Component);

  Base.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    var ret = {};
    var validation = props.validation,
        isInDetail = props.isInDetail;

    var behavior = (0, _formFieldUtils.calculateBehavior)(props);
    var fieldData = (0, _formFieldUtils.calculateFieldData)(props);
    var options = (0, _formFieldUtils.calculateOptions)(props);
    if (behavior !== state.behavior) {
      ret = _extends(ret, {
        behavior: behavior
      });
    }
    if (!(0, _lodash.isEqual)(validation, state.validation)) {
      ret = _extends(ret, {
        validation: validation,
        required: !isInDetail && (0, _formFieldUtils.checkIsRequired)(validation)
      });
    }
    if (!(0, _lodash.isEqual)(fieldData, state.fieldData)) {
      ret = _extends(ret, {
        fieldData: fieldData
      });
    }
    if (!(0, _lodash.isEqual)(options, state.options)) {
      ret = _extends(ret, {
        options: options
      });
    }

    return Object.keys(ret).length > 0 ? ret : null;
  };

  function Base(props) {
    _classCallCheck(this, Base);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    var behavior = props.behavior,
        fieldId = props.fieldId,
        fieldName = props.fieldName;


    _this.state = {
      behavior: behavior,
      validation: null,
      required: false,
      fieldSelectedStatus: false, // 表单项选择模式开启关闭状态
      fieldSelectedChecked: false // 表单项选择模式选项选中状态
    };

    _this.name = fieldName || fieldId;

    _this.renderView = _this.renderView.bind(_this);
    _this.renderDefaultView = _this.renderDefaultView.bind(_this);
    _this.renderControl = _this.renderControl.bind(_this);

    _this.fieldCheckboxOnChange = _this.fieldCheckboxOnChange.bind(_this);
    return _this;
  }

  Base.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    // TODO
    var $state = this.props.$state;

    if ($state) {
      $state.fieldDataFormatter = this.fieldDataFormatter.bind(this);
    }

    // 更新表单项选择模式数据
    if (this.props.context && !this.props.disableFieldSelect) {
      var fieldsSelectModeStatus = this.props.context.getGlobal('fieldsSelectModeStatus') || false;
      var fieldsSelectModeData = this.props.context.getGlobal('fieldsSelectModeData') || [];
      this.setState({
        fieldSelectedStatus: fieldsSelectModeStatus,
        fieldSelectedChecked: fieldsSelectModeData.findIndex(function (i) {
          return i && i.fieldId === _this2.props.fieldId;
        }) >= 0
      });
    }
  };

  Base.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var _this3 = this;

    // 更新表单项选择模式数据
    if (this.props.context && !this.props.disableFieldSelect) {
      var fieldsSelectModeStatus = this.props.context.getGlobal('fieldsSelectModeStatus') || false;
      var fieldsSelectModeData = this.props.context.getGlobal('fieldsSelectModeData') || [];
      var checked = fieldsSelectModeData.findIndex(function (i) {
        return i && i.fieldId === _this3.props.fieldId;
      }) >= 0;

      // 判断是否更新，否则会循环渲染
      if (this.state.fieldSelectedStatus !== fieldsSelectModeStatus || this.state.fieldSelectedChecked !== checked) {
        this.setState({
          fieldSelectedStatus: fieldsSelectModeStatus,
          fieldSelectedChecked: checked
        });
      }
    }
  };

  // 用于子类获取父类this.state


  Base.prototype.getComponentState = function getComponentState() {
    return this.state;
  };

  /**
   * gov 定制
   * 获取单选、复选、下拉等组件的选项列表
   */


  Base.prototype.getOptions = function getOptions() {
    var needConvert = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var _props = this.props,
        cascadeSize = _props.cascadeSize,
        needCompleteOptions = _props.needCompleteOptions;
    var options = this.state.options;

    var fieldValue = this.getFieldValue();
    if (needCompleteOptions && (0, _lodash.isEmpty)(options) && !(0, _lodash.isEmpty)(fieldValue)) {
      options = (0, _formFieldUtils.completeOptions)(fieldValue);
    }
    if (needConvert) {
      options = (0, _formFieldUtils.convertOptionsText)(options);
    }
    if (!(0, _lodash.isNil)(cascadeSize)) {
      options = (0, _formFieldUtils.convertOptionsCascade)((0, _lodash.cloneDeep)(options), cascadeSize);
    }
    return options;
  };

  Base.prototype.getCascadeSize = function getCascadeSize() {
    var cascadeSize = this.props.cascadeSize;

    if (!(0, _lodash.isNil)(cascadeSize)) {
      return cascadeSize;
    }
    var options = this.state.options;

    var calculateCascade = function calculateCascade(list, currentSize) {
      if ((0, _lodash.isEmpty)(list)) {
        return currentSize;
      }
      var children = [];
      (0, _lodash.forEach)(list, function (item) {
        if (item && !(0, _lodash.isEmpty)(item.children)) {
          children.push.apply(children, _toConsumableArray(item.children));
        }
      });
      if (!(0, _lodash.isEmpty)(children)) {
        return calculateCascade(children, currentSize + 1);
      } else {
        return currentSize;
      }
    };
    return calculateCascade(options, 1);
  };

  Base.prototype.getBehavior = function getBehavior() {
    return this.state.behavior || 'NORMAL';
  };

  // getValue时触发，外部store向组件中赋值时的转换


  Base.prototype.formatIn = function formatIn(value) {
    var _props2 = this.props,
        componentName = _props2.componentName,
        $state = _props2.$state;

    return (0, _formatter.formatIn)(value, componentName, $state);
  };

  Base.prototype.triggerGlobalEvent = function triggerGlobalEvent(event) {
    var _props3 = this.props,
        fieldId = _props3.fieldId,
        $state = _props3.$state;

    var store = $state.getRoot();
    return store.emitter.emit(fieldId + ':' + event);
  };

  Base.prototype.getInstance = function getInstance(component) {
    var _getProps = this.getProps(),
        $props = _getProps.$props,
        componentId = _getProps.componentId,
        context = _getProps.context;

    var fieldId = (0, _lodash.get)(component, 'props.fieldId');
    var iteratorId = $props.iteratorId || componentId;
    return context.getComponentInstance(iteratorId + '_' + fieldId);
  };
  /**
   * 卡片分栏、灵活分栏里获取index方式不同
   * @param {*} parents
   * @returns
   */


  Base.prototype.getIndex = function getIndex(parents) {
    var _getProps2 = this.getProps(),
        $props = _getProps2.$props;

    var COLUMNS_LAYOUT_LIST = [_constant.AUTO_COLUMNS_LAYOUT, _constant.COLUMNS_LAYOUT];

    if (parents.some(function (parent) {
      return COLUMNS_LAYOUT_LIST.includes(parent.componentName);
    })) {
      var autoColumnField = parents.find(function (parent) {
        return COLUMNS_LAYOUT_LIST.includes(parent.componentName);
      });
      var instance = this.getInstance(autoColumnField);
      return (0, _lodash.get)(instance, 'props.$props.index', 0);
    }
    return (0, _lodash.get)($props, 'index', 0);
  };

  Base.prototype.findParentComponent = function findParentComponent() {
    var _props4 = this.props,
        context = _props4.context,
        initialSchema = _props4.initialSchema;

    var parentComponents = (0, _treeOperation.getAllParents)(context.schema, (0, _lodash.get)(initialSchema, 'id', ''));
    var cardEle = parentComponents.find(function (component) {
      return (0, _lodash.isEqual)(component.componentName, _constant.CARD_COMPONENT_TYPE_NAME);
    });

    var _getCardFieldId = (0, _card.getCardFieldId)(parentComponents, cardEle),
        fieldId = _getCardFieldId.fieldId,
        inAdvancedCard = _getCardFieldId.inAdvancedCard;

    var index = this.getIndex(parentComponents);

    return {
      state: context.store.get(fieldId),
      index: index,
      inAdvancedCard: inAdvancedCard
    };
  };
  /**
   * 支持卡片分栏、灵活分栏
   */


  Base.prototype.triggerCardItemChangeEvent = function triggerCardItemChangeEvent() {
    var _props5 = this.props,
        fieldId = _props5.fieldId,
        context = _props5.context;

    var _findParentComponent = this.findParentComponent(),
        state = _findParentComponent.state,
        index = _findParentComponent.index,
        inAdvancedCard = _findParentComponent.inAdvancedCard;

    var changeFunc = (0, _lodash.get)(state, 'emitter._events.onCardItemChange');
    // 卡片里的元素才会注册onCardItemChange函数
    if ((0, _lodash.isFunction)(changeFunc)) {
      changeFunc({ fieldId: fieldId, index: index });
      // TODO: 嵌套卡片中的卡片目前只能通过此方法触发
      if (inAdvancedCard) {
        var event = (0, _lodash.get)(context, ['globalEvents', fieldId, 'onOpenIframeModal', 0]);
        event && event();
      }
    }
  };

  // onChange时触发，组件的值向全局store中赋值时的转换


  Base.prototype.formatOut = function formatOut(value) {
    var _props6 = this.props,
        componentName = _props6.componentName,
        $state = _props6.$state;

    var options = this.getOptions();
    return (0, _formatter.formatOut)(value, componentName, options, $state);
  };

  Base.prototype.defaultValueFormatter = function defaultValueFormatter(value) {
    var _props7 = this.props,
        componentName = _props7.componentName,
        $state = _props7.$state;

    var options = this.getOptions();
    return (0, _formatter.defaultValueFormatter)(value, componentName, $state, options);
  };

  Base.prototype.fieldDataFormatter = function fieldDataFormatter(value) {
    var _props8 = this.props,
        componentName = _props8.componentName,
        $state = _props8.$state;

    var options = this.getOptions();
    return (0, _formatter.fieldDataFormatter)(value, componentName, options, $state);
  };

  Base.prototype.getValue = function getValue() {
    return this.formatIn((this.state.fieldData || {}).value);
  };

  Base.prototype.getFieldValue = function getFieldValue() {
    var $state = this.props.$state;

    return $state && $state.getVal();
  };

  Base.prototype.getProps = function getProps() {
    return this.props;
  };

  Base.prototype.reset = function reset() {
    // TODO

    var toDefault = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  };

  Base.prototype.getSizeClass = function getSizeClass() {
    var size = this.props.size;

    return SIZE_CLASS[size];
  };

  Base.prototype.getFormItemProps = function getFormItemProps() {
    var props = this.getProps();
    var behavior = this.getBehavior();
    var tips = this.renderTips();
    var layout = (0, _formFieldUtils.calculateLayout)(props);
    var labelAlign = (0, _formFieldUtils.calculateLabelAlign)(props);

    var showLabel = props.showLabel,
        hasError = props.hasError,
        errorMsg = props.errorMsg,
        correctionTip = props.correctionTip,
        onTriggerRequest = props.onTriggerRequest,
        onOpenIframeModal = props.onOpenIframeModal,
        recommend = props.recommend;

    var showTriggerBtn = !!onTriggerRequest || !!onOpenIframeModal || !!recommend;
    var required = this.state.required;

    // 根据 Fusion 内部的实现，当没有错误信息时 help 的值一定要等于 undefined

    var help = undefined;
    if (!(0, _lodash.isEmpty)(correctionTip)) {
      help = correctionTip;
    }
    if (hasError) {
      help = errorMsg;
    }

    var ret = _extends({}, layout, {
      className: (0, _classnames2.default)('vc-form-item', props.fieldClassName, props.className, {
        'vc-form-item-hidden': behavior === 'HIDDEN',
        'vc-form-item-readonly': behavior === 'READONLY',
        'vc-field-has-trigger-request-btn': showTriggerBtn,
        'vc-form-item-label-align-left': labelAlign === 'left'
      }),
      'data-field-id': props.fieldId,
      style: props.style,
      size: SIZE[props.size],
      labelTextAlign: props.labelTextAlign,
      labelAlign: labelAlign,
      label: showLabel ? props.label : '',
      hasFeedback: props.hasFeedback || false,
      validateState: hasError || !(0, _lodash.isEmpty)(correctionTip) ? 'error' : null,
      help: help,
      extra: tips,
      required: required
    });

    return ret;
  };

  Base.prototype.getVeFormItemProps = function getVeFormItemProps() {
    var props = this.getFormItemProps();
    var behavior = this.getBehavior();

    if (behavior === 'HIDDEN') {
      props.label = props.label + '（隐藏）';
    }
    return props;
  };

  Base.prototype.getControlProps = function getControlProps() {
    var _this4 = this;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$trigger = _ref.trigger,
        trigger = _ref$trigger === undefined ? 'onChange' : _ref$trigger;

    var _props9 = this.props,
        fieldId = _props9.fieldId,
        placeholder = _props9.placeholder,
        _onChange = _props9.onChange,
        _onBlur = _props9.onBlur,
        onFocus = _props9.onFocus,
        hasClear = _props9.hasClear,
        autoFocus = _props9.autoFocus,
        __fieldProps = _props9.__fieldProps,
        componentName = _props9.componentName;


    var fieldProps = __fieldProps;

    var behavior = this.getBehavior();
    return _extends({
      disabled: behavior === 'DISABLED',
      readOnly: behavior === 'READONLY',
      hasClear: hasClear,
      placeholder: placeholder,
      onBlur: function onBlur() {
        if ((0, _lodash.isFunction)(_onBlur)) {
          if (componentName === 'RegionSelect') {
            _onBlur({ componentProps: _this4.props });
          } else {
            setTimeout(function () {
              return _onBlur({ componentProps: _this4.props });
            }, 100);
          }
        }
      },
      onFocus: onFocus,
      autoFocus: autoFocus,
      popupClassName: (0, _classnames2.default)('vc-form-item-popup', 'vc-form-item-overlay-' + fieldId, {
        'vc-form-item-hidden': behavior === 'HIDDEN'
      }),
      // popupContainer: <div {...{ 'data-field-id': fieldId }}></div>,
      value: this.getValue(),
      onChange: function onChange(value) {
        if ((0, _lodash.isFunction)(_onChange)) {
          _onChange({ value: _this4.formatOut(value) });
        }
      }
    }, fieldProps);
  };

  // 获取是否渲染表单项选择模式状态


  Base.prototype.getFieldSelectedRenderFlag = function getFieldSelectedRenderFlag() {
    // 若在vision引擎中或选择模式未开启或本身表单项是隐藏的，则不渲染表单项选择模式
    return !window.VisualEngine && !this.props.disableFieldSelect && this.props.isInDetail && this.state.fieldSelectedStatus && this.props.visible;
  };

  // 获取是否展示补齐补正信息渲染状态


  Base.prototype.getSupplementRenderFlag = function getSupplementRenderFlag() {
    // C端沿用correctionTip字段，在field 错误区域展示，不用单独去渲染，办件详情中需要单独去取渲染
    return !window.VisualEngine && !this.props.disableFieldSelect && this.props.isInDetail && this.props.correctionIconMessage;
  };

  Base.prototype.renderTips = function renderTips() {
    var _this5 = this;

    var _getProps3 = this.getProps(),
        tips = _getProps3.tips,
        tipsType = _getProps3.tipsType,
        info = _getProps3.info,
        onRequest = _getProps3.onRequest,
        failed = _getProps3.failed,
        isInDetail = _getProps3.isInDetail;

    if (isInDetail || !tips && !info && !failed) {
      return null;
    }
    return _react2.default.createElement(
      'div',
      { style: { width: '100%' } },
      tips && tipsType === 'ICON' && _react2.default.createElement(
        _next.Balloon,
        {
          trigger: _react2.default.createElement(_next.Icon, { type: 'prompt', size: 'small', className: 'vc-field-tips-icon' }),
          align: 'tl',
          closable: false
        },
        _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: tips } })
      ),
      tips && tipsType !== 'ICON' && _react2.default.createElement('p', { className: 'vc-field-info', dangerouslySetInnerHTML: { __html: tips } }),
      (0, _lodash.isEmpty)(tips) && info && _react2.default.createElement(
        'p',
        { className: 'vc-field-info' },
        info
      ),
      failed && onRequest && _react2.default.createElement(
        'div',
        { className: 'vc-gov-failed-refresh' },
        '\u7F51\u7EDC\u5F02\u5E38\uFF0C\u5185\u5BB9\u83B7\u53D6\u5931\u8D25\uFF0C',
        _react2.default.createElement(
          'a',
          {
            onClick: function onClick(e) {
              e.preventDefault();
              e.stopPropagation();
              if ((0, _lodash.isFunction)(onRequest)) {
                onRequest();
              } else {
                _this5.triggerGlobalEvent('onRequest');
              }
            }
          },
          '\u91CD\u65B0\u83B7\u53D6'
        )
      )
    );
  };

  Base.prototype.renderRequestButton = function renderRequestButton() {
    var _this6 = this;

    var _getProps4 = this.getProps(),
        onTriggerRequest = _getProps4.onTriggerRequest,
        onOpenIframeModal = _getProps4.onOpenIframeModal,
        _getProps4$onOpenIfra = _getProps4.onOpenIframeModalData,
        onOpenIframeModalData = _getProps4$onOpenIfra === undefined ? {} : _getProps4$onOpenIfra,
        requestBtn = _getProps4.requestBtn,
        isInDetail = _getProps4.isInDetail,
        hideRequestBtn = _getProps4.hideRequestBtn;

    if ((0, _lodash.isNil)(onTriggerRequest) && (0, _lodash.isNil)(onOpenIframeModal) || hideRequestBtn) {
      return null;
    }

    // https://aone.alibaba-inc.com/v2/project/1006197/req/46046201
    // 需求中只是要在详情页中加onOpenIframeModal事件支持，onTriggerRequest不在详情页支持
    if (isInDetail) {
      // frameRequest参数中的detailEnable字段配置设置为true，则进行渲染
      if (onOpenIframeModal && onOpenIframeModalData && onOpenIframeModalData.detailEnable) {} else {
        return null;
      }
    }

    var btnWidth = (0, _lodash.isEmpty)(requestBtn) ? '5em' : requestBtn + 2 + 'em';
    return _react2.default.createElement(
      _next.Button,
      {
        title: requestBtn || '查询',
        type: 'secondary',
        className: 'vc-trigger-request-btn',
        style: { flexBasis: btnWidth },
        onClick: function onClick() {
          if ((0, _lodash.isFunction)(onTriggerRequest)) {
            onTriggerRequest();
          } else if (onTriggerRequest) {
            _this6.triggerGlobalEvent('onTriggerRequest');
          }

          if ((0, _lodash.isFunction)(onOpenIframeModal)) {
            // feat: https://aone.alibaba-inc.com/v2/project/1139609/req/39988194
            // 注意看aOne里的备注
            _this6.triggerCardItemChangeEvent();
            onOpenIframeModal();
          } else if (onOpenIframeModal) {
            _this6.triggerGlobalEvent('onOpenIframeModal');
          }
        }
      },
      requestBtn || '查询'
    );
  };

  /** 智能填写 */


  Base.prototype.renderSmartInput = function renderSmartInput() {
    var _getProps5 = this.getProps(),
        isInDetail = _getProps5.isInDetail,
        recommend = _getProps5.recommend,
        _getProps5$writeBtn = _getProps5.writeBtn,
        writeBtn = _getProps5$writeBtn === undefined ? '智能填写' : _getProps5$writeBtn,
        label = _getProps5.label,
        fieldId = _getProps5.fieldId;

    var _getControlProps = this.getControlProps(),
        onChange = _getControlProps.onChange,
        value = _getControlProps.value;

    if (isInDetail || !recommend) {
      return null;
    }
    return _react2.default.createElement(_recommend2.default, { fieldCode: fieldId, fieldName: label, onChange: onChange, writeBtn: writeBtn, value: value });
  };

  // TODO 抽出去


  Base.prototype.renderLevelControlAddon = function renderLevelControlAddon() {
    var _props10 = this.props,
        _onChange2 = _props10.onChange,
        fieldData = _props10.fieldData,
        levelControlAddon = _props10.levelControlAddon,
        isChildComponent = _props10.isChildComponent;

    var value = fieldData && fieldData.eleContentRuleConfigVO;
    return !isChildComponent && levelControlAddon && levelControlAddon({
      value: value,
      onChange: function onChange(eleContentRuleConfigVO) {
        _onChange2({ eleContentRuleConfigVO: eleContentRuleConfigVO });
      }
    });
  };

  Base.prototype.renderView = function renderView() {
    var props = this.getProps();
    var value = this.getFieldValue();
    if (props.renderView) {
      return props.renderView(value, props);
    }

    return this.renderDefaultView(value, props);
  };

  Base.prototype.renderDefaultView = function renderDefaultView(value) {
    var realValue = this.defaultValueFormatter(value);
    return _react2.default.createElement(
      'span',
      { className: 'vc-form-item-view-text', title: realValue },
      (0, _lodash.isNil)(realValue) ? _formFieldUtils.EMPTY_TEXT : realValue
    );
  };

  Base.prototype.renderControl = function renderControl() {
    return _react2.default.createElement(
      'div',
      null,
      '\u8868\u5355\u7EC4\u4EF6\u5360\u4F4D\uFF0C\u8BF7\u91CD\u8F7D renderControl \u65B9\u6CD5'
    );
  };

  // 占位用于渲染表单项筛选，tips


  Base.prototype.renderFieldCheckboxTips = function renderFieldCheckboxTips() {
    return null;
  };

  // 当开启fieldSelect模式时，渲染表单每一项前面的checkbox


  Base.prototype.renderFieldCheckbox = function renderFieldCheckbox() {
    if (!this.getFieldSelectedRenderFlag()) {
      return null;
    }

    return _react2.default.createElement(
      'span',
      { className: 'item-field-select-wrap' },
      _react2.default.createElement(_next.Checkbox, {
        className: 'item-field-select-checkbox',
        checked: this.state.fieldSelectedChecked || false,
        onChange: this.fieldCheckboxOnChange
      }),
      this.renderFieldCheckboxTips()
    );
  };

  // 获取选中表单项后的格式化value值，抽象该方法用于子类的覆写定制


  Base.prototype.getSelectFieldFormatValue = function getSelectFieldFormatValue() {
    var value = this.defaultValueFormatter(this.getFieldValue());
    return (0, _lodash.isNil)(value) ? _formFieldUtils.EMPTY_TEXT : value;
  };

  // form field checkbox 选中变化handler


  Base.prototype.fieldCheckboxOnChange = function fieldCheckboxOnChange(checked, e) {
    // 更新当前表单项选择模式状态
    this.setState({ fieldSelectedChecked: checked });

    // 读取全局状态中表单选项模式数据
    var fieldsSelectModeData = (0, _lodash.cloneDeep)(this.props.context.getGlobal('fieldsSelectModeData') || []);

    var _props11 = this.props,
        componentName = _props11.componentName,
        label = _props11.label,
        fieldId = _props11.fieldId;

    var value = this.getSelectFieldFormatValue();

    // 更丰富的数据给应用层使用
    var newData = {
      componentName: componentName,
      label: label,
      fieldId: fieldId,
      value: value
    };

    var idx = fieldsSelectModeData.findIndex(function (i) {
      return i && i.fieldId === fieldId;
    });
    if (checked) {
      // 若存在重复的fieldId则替换，否则追加数据
      if (idx >= 0) {
        fieldsSelectModeData.splice(idx, 1, newData);
      } else {
        fieldsSelectModeData.push(newData);
      }
    } else {
      // 取消选中，剔除对应已选中的fieldId数据
      if (idx >= 0) {
        fieldsSelectModeData.splice(idx, 1);
      }
    }

    // 更新全局状态中表单选项模式数据
    this.props.context.setGlobal({ fieldsSelectModeData: fieldsSelectModeData });

    typeof this.props.onFieldsSelectChange === 'function' && this.props.onFieldsSelectChange({
      checked: checked,
      currentData: newData || {},
      selectedData: [].concat(_toConsumableArray(fieldsSelectModeData))
    });
  };

  // 渲染补齐补正信息


  Base.prototype.renderSupplement = function renderSupplement() {
    if (!this.getSupplementRenderFlag()) {
      return null;
    }

    var _props12 = this.props,
        correctionTip = _props12.correctionTip,
        correctionIconMessage = _props12.correctionIconMessage,
        isInDetail = _props12.isInDetail;


    return _react2.default.createElement(
      'div',
      {
        className: (0, _classnames2.default)('item-field-supplement', {
          'item-field-supplement-icon': isInDetail
        })
      },
      isInDetail ? correctionIconMessage : correctionTip
    );
  };

  Base.prototype.render = function render() {
    var behavior = this.getBehavior();
    var props = void 0;
    if (window.VisualEngine) {
      props = this.getVeFormItemProps();
    } else {
      props = this.getFormItemProps();
    }

    var mainFormItem = _react2.default.createElement(
      _next.Form.Item,
      props,
      behavior === 'READONLY' ? _react2.default.createElement(
        'div',
        { className: 'vc-form-item-view' },
        this.renderView()
      ) : this.renderControl(),
      this.renderRequestButton(),
      this.renderSmartInput(),
      this.renderLevelControlAddon()
    );

    return _react2.default.createElement(
      'div',
      { className: 'vc-form-item-container' },
      this.getFieldSelectedRenderFlag() || this.getSupplementRenderFlag() ? _react2.default.createElement(
        'div',
        { className: 'item-field-flex-container' },
        this.renderFieldCheckbox(),
        mainFormItem,
        this.renderSupplement()
      ) : mainFormItem
    );
  };

  return Base;
}(_react2.default.Component), _class.propsTypes = {
  fieldData: _propTypes2.default.object,
  errorMsg: _propTypes2.default.string
}, _class.defaultProps = {
  showLabel: true,
  hasClear: false,
  fieldData: {},
  requestBtn: '查询',
  isInDetail: false,
  global: {}
}, _class.mutableStates = ['fieldId', 'fieldName', 'label', 'validation', 'behavior', 'visible', 'readonly', 'disabled', 'dataShare', 'globalErrorMsg', 'precision', 'fixedNum', 'unit', 'delimiter', 'dateType', 'format', 'showPrefix', 'prefix', 'showSuffix', 'suffix', {
  name: 'groupId',
  formatOut: false
}, {
  name: 'placeholder',
  formatOut: false
}, {
  name: 'initialSchema',
  formatIn: function formatIn(initialSchema, props, states) {
    var componentSchema = states.componentSchema;

    return componentSchema || {};
  }
}, {
  name: 'fieldData',
  formatOut: function formatOut(fieldData, data) {
    return fieldData;
  }
}, 'dataSource', {
  name: 'options',
  formatIn: function formatIn(options, props) {
    var dataSource = props.get('dataSource');
    var realOptions = void 0;
    if (Array.isArray(options) && !(0, _lodash.isEmpty)(options)) {
      realOptions = options;
    } else if (dataSource.value && !(0, _lodash.isEmpty)(dataSource.value.options)) {
      realOptions = dataSource.value.options;
    }
    if (!(0, _lodash.isEmpty)(realOptions)) {
      realOptions = realOptions.filter(function (item) {
        return item.text && !(0, _lodash.isNil)(item.value);
      });
    }
    return realOptions || [];
  }
}, {
  name: 'errorMsg',
  formatOut: function formatOut(errorMsg) {
    return errorMsg || null;
  }
}, {
  name: 'hasError',
  formatOut: function formatOut(hasError) {
    return !!hasError;
  }
}, 'correctionTip', 'corrected'], _class.defaultMutators = {
  onChange: function onChange(_ref2, fieldData) {
    var state = _ref2.state;

    if (fieldData && fieldData.hasOwnProperty('value') && (0, _lodash.isEmpty)(fieldData.value)) {
      // fieldData.value 为空时无法赋值
      state.setVal(fieldData.value);
    }
    state.merge('fieldData', _extends({
      dataType: 'CHANGED'
    }, fieldData));
  }
}, _temp);
exports.default = Base;
module.exports = exports['default'];